import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify, { themeColor } from './plugins/vuetify.js';
import checkToken from './services/authentication/checkToken.js';
import './registerServiceWorker.js'
import './services/mqtt/configuration.js';
import { store } from './store/store.js'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './components/GlobalComponents.js'

/*  // msal.js - AZURE Auth with a fallback to backup CDN
msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_CLIENTID,
    authority: process.env.VUE_APP_AZURE_AUTHORITY,
    redirectUri: process.env.VUE_APP_AZURE_REDIRECTURI,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
myMSALObj = new Msal.UserAgentApplication(msalConfig); 
*/

Vue.config.performance = true;
const eventBus = new Vue();

export {
  themeColor,
  eventBus
};

new Vue({
  router,
  vuetify,
  store,
  mixins: [checkToken],
  render: h => h(App)
}).$mount('#app')
